import React, { useEffect, useState } from "react";
import { Minus, Plus, Search, ShoppingCart, Download } from "lucide-react";
// import { toast } from "react-toastify";
import { useProductStore } from "../../store/useProductStore";
import { useAuthStore } from "../../store/useAuthStore";
import ProductModal from "./ProductModal"; // Import the ProductModal component
import { Pagination, Stack } from "@mui/material";
import { useSummaryStore } from "../../store/useSummaryStore";
import Loader from "../../components/Loader/Loader";
import Card from "../../components/Card/Card";
import Datepicker from "react-tailwindcss-datepicker";
import moment from "moment";
import { useDistributorStore } from "../../store/useDistributorStore";
import { toast } from "react-toastify";
import LeftTable from "../../components/Table/LeftTable";
import RightTable from "../../components/Table/RightTable";
import orderServices from '../../services/order.service';
import './summary.css';

const SummaryTable = () => {
    const { user } = useAuthStore();
    const USER_ROLE = user?.userDataObj?.role;
    const { fetchProducts, setCartCount, fetchSkuMakeandSegment } = useProductStore();
    const [summary,setSummary] = useState([])
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [totalCount, setTotalCount] = useState(null);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [states,setStates] = useState([])
    const [districts,setDistricts] = useState([])
    const [tabData,setTabData] = useState([])
    const cartCount = useProductStore((state) => state.cartCount);
    const [zonalManagers, setZonalManagers] = useState([])
    const [filter, setFilter] = useState({
        limit: 10,
        offset: 1,
        state_id: [],
        district_id: [],
        status_id: undefined,
        region_id: [],
        distrNameOrNumber: '',
        order_id: undefined,
        zonal_manager_id: undefined,
    })

    const [value, setValue] = useState(null);
    const [isOpen, setIsOpen] = useState(false);

    const handleToggle = () => setIsOpen((prev) => !prev);

    const [isLoading, setIsLoading] = useState(false);

    console.log(states, 'states')

    const [make, setMake] = useState([])
    const [size, setSize] = useState([])
    const [segment, setSegment] = useState([])

    const {fetchStatesList,fetchDistrictsList} = useDistributorStore()
    const { fetchSummary,fetchAdminSummary,summeryDownloadAdmin,summeryDownloadDistr } = useSummaryStore();

    const statusOptions = [
      { value: 4, label: "Order Placed" },
      { value: 11, label: "Order Approved" },
      { value: 12, label: "Order Rejected" },
      { value: 13, label: "Order Dispatched" },
      { value: 14, label: "Order Delivered" },
      { value: 18, label: "Delivery Confirmed"},
      { value: 19, label: "Order Is On Hold"},
    ];

    const zoneOptions = [
      {value : 1, label : 'North'},
      {value : 2, label : 'East'},
      {value : 3, label : 'West'},
      {value : 4, label : 'South'},
    ];

    // Get cart data from localStorage (product_data)
    const getCartData = () => {
        return JSON.parse(localStorage.getItem("product_data")) || [];
    };

    const fetchData = async (filter) => {
        if(!USER_ROLE && !user?.userDataObj?.user_id) return;
        setIsLoading(true);
        const res =  (USER_ROLE === 4 || USER_ROLE == 5) ? await fetchAdminSummary({...filter, user_id: user?.userDataObj?.user_id})  : await fetchSummary({...filter, user_id: user?.userDataObj?.user_id});
        if (res.status) {
            console.log(res)
            setTotalPages(res.data.pagination.totalPages);
            setTotalCount(res.data.count);
            setSummary(res.data.data);
            setTabData(res.data.tabData)
        } else {
            setTotalPages(1);
            setTotalCount(0);
            setSummary([]);
        }
        setIsLoading(false);
    };

    const fetchSkuMakeandSegmentData = async () => {
        const res = await fetchSkuMakeandSegment();

        if (res.status) {
            const { make, segment, size } = res.data;
            setMake(make);
            setSegment(segment);
            setSize(size);
        } else {
            setMake([]);
            setSegment([]);
            setSize([]);
        }

    };

    const handleAdminDownload = async () => {
      const response = await summeryDownloadAdmin({...filter, user_id: user?.userDataObj?.user_id, zonal_manager_id: filter.zonal_manager_id})
      if(response.status === true) {
        toast.success(response?.data?.data?.message, {toastId: 'successMessageAdminSummary'})
      } else if(response?.data?.statusText === "Not Found") {
        toast.error('Data Not Found', {toastId: 'errorMessageAdminDownload'})
      } else {
        toast.error("Failed To Download", {toastId: 'errorMessageAdminDownload'})
      }
    }

    const handleDistrDownload = async () => {
      const response = await summeryDownloadDistr({...filter, user_id: user?.userDataObj?.user_id, zonal_manager_id: filter.zonal_manager_id})
      if(response.status === true) {
        toast.success(response?.data?.data?.message, {toastId: 'successMessageDistrSumary'})
      } else if(response?.data?.statusText === "Not Found") {
        toast.error('Data Not Found', {toastId: 'errorMessageDistrDownload'})
      } else {
        toast.error("Failed To Download", {toastId: 'errorMessageDistrDownload'})
      }
    }

    // State to manage cart data
    const [cartData, setCartData] = useState(getCartData());

    useEffect(() => {
        // Update cart count whenever cartData changes
        setCartCount(cartData.filter(value => value?.ordered_quantity > 0).length);
    }, [cartData, setCartCount]);

    const handlePageChange = (pageNumber) => {
        setCurrentPage(pageNumber);
        setFilter({ ...filter, offset: pageNumber })
    };

    const fetchStates = async () => {
      setIsLoading(true)
      const res = await fetchStatesList()

      if(res.status) {
        setStates(res.data)
      }
    }

    const fetchDistricts = async (state_id) => {
      let params = {state_id : state_id}
      const res = await fetchDistrictsList(params)

      if(res.status) {
        setDistricts(res.data)
      }
    }

    const handleSearch = () => {
      setCurrentPage(1);

      console.log(value)
  
      setFilter((prevFilter) => {
          const updatedFilter = { 
              ...prevFilter, 
              offset: 1
          };
  
          if (USER_ROLE === 4 || USER_ROLE === 5) {
              updatedFilter.distributor_name = !Number(prevFilter.distrNameOrNumber) ? prevFilter.distrNameOrNumber.trim() : '';
              updatedFilter.mobile = Number(prevFilter.distrNameOrNumber) ? prevFilter.distrNameOrNumber.trim() : '';
          } else {
            updatedFilter.order_id = updatedFilter.order_id ? updatedFilter.order_id.trim() : undefined;
          }

          if(value) {
              updatedFilter.start_date = new moment(value?.startDate)?.format('YYYY-MM-DD');
              updatedFilter.end_date = new moment(value?.endDate)?.format('YYYY-MM-DD');
            }
  
          fetchData(updatedFilter);
          return updatedFilter;
      });
  };

    const handleReset = () => {
        setFilter({
          limit: 10,
          offset: 1,
          state_id: [],
          district_id: [],
          status_id: undefined,
          region_id: [],
          distrNameOrNumber: '',
          order_id: undefined,
          zonal_manager_id: undefined,
        })
        setValue(null,null)
        setCurrentPage(1)
        fetchData({ limit: 10, offset: 1});
    }

    useEffect(() => {
      fetchStates()
    }, []);

    useEffect(() => {
      if(filter.state_id) fetchDistricts(filter.state_id)
    }, [filter.state_id]);

    useEffect(() => {
        fetchData(filter);
    }, [currentPage]);

    useEffect(() => {
        fetchSkuMakeandSegmentData();
    }, []);

    useEffect(() => {
      const fetchZonalManagers = async (id=null) => {
        try {
          const response = await orderServices.getZonalList(id);
          if (response.status) {
            setZonalManagers(response.data.map(item => ({value: item.user_id,label: item.firstName + " " + item.lastName})) || []);
          } else {
            setZonalManagers([]);
          }
        } catch (error) {
          toast.error(error.message || 'Failed to fetch zonal managers.', {toastId: 'errorMessageFetchZonalManagers'});
          setZonalManagers([]);
        }
      };
      if (filter.region_id && filter.region_id !== "all") {
        fetchZonalManagers(filter.region_id);
      } else {
        fetchZonalManagers();
      }
    }, [filter.region_id])

    useEffect(() => {
      handleSearch();
    },[filter.state_id, filter.district_id, filter.region_id, filter.status_id, filter.zonal_manager_id, value])

    const handleKeyDown = (event) => {
      if (event.key === "Enter") {
        handleSearch();
      }
    };

      if(isLoading){
        return <Loader />
      }

    return (
      <>
        <div className="overflow-x-auto">
          <div className="flex justify-end mb-1 mt-2 mr-1">
            <button
              onClick={() =>
                (USER_ROLE === 4 || USER_ROLE === 5) ? handleAdminDownload() : handleDistrDownload()
              }
              className="inline-flex items-center px-3 py-1.5 text-sm font-medium text-emerald-600 bg-emerald-100 rounded-md hover:bg-emerald-200 focus:outline-none focus:ring-2 focus:ring-emerald-500"
            >
              <Download className="mr-1.5 h-3 w-3" />
              Download
            </button>
          </div>
          {/* <div
            style={{
              display: "flex",
              justifyContent: "center",
              padding: "0 20px 20px 20px",
            }}
          >
            <Card
              title="Total Billing Value (Dispatched)"
              value={`₹${tabData?.totalBillingValue?.cost ?? 0}`}
              subValue={[
                `${tabData?.totalBillingValue?.totalOrders ?? 0} orders`,
              ]}
              flexBasis="20%"
            />
            <Card
              title="Total Invoice Value (Dispatched)"
              value={`₹${tabData?.totalInvoiceBillingValue?.cost ?? 0}`}
              subValue={[
                `${tabData?.totalInvoiceBillingValue?.totalOrders ?? 0} orders`,
              ]}
              flexBasis="20%"
            />
            <Card
              title="Total Sets (Dispatched)"
              value=""
              subValue={
                (USER_ROLE === 4 || USER_ROLE === 5)
                  ? [
                      `HCV - ${
                        tabData?.overAllTotalBilledQuantity?.HCV
                          ?.approved_quantity ?? 0
                      }`,
                      `LCV - ${
                        tabData?.overAllTotalBilledQuantity?.LCV
                          ?.approved_quantity ?? 0
                      }`,
                      `TRL - ${
                        tabData?.overAllTotalBilledQuantity?.TRL
                          ?.approved_quantity ?? 0
                      }`,
                      `OHW - ${
                        tabData?.overAllTotalBilledQuantity?.OHW?.approved_quantity ??
                        0
                      }`,
                    ]
                  : [
                      `HCV - ${
                        tabData?.totalBilledQuantity?.HCV?.approved_quantity ??
                        0
                      }`,
                      `LCV - ${
                        tabData?.totalBilledQuantity?.LCV?.approved_quantity ??
                        0
                      }`,
                      `TRL - ${
                        tabData?.totalBilledQuantity?.TRL?.approved_quantity ??
                        0
                      }`,
                      `OHW - ${
                        tabData?.totalBilledQuantity?.OHW?.approved_quantity ??
                        0
                      }`,
                    ]
              }
              flexBasis="20%"
            />
            <Card
              title="Total Hold Orders"
              value={
                (USER_ROLE === 4 || USER_ROLE === 5)
                  ? `Billing amount - ${
                      tabData?.overAllTotalHoldBillingValue?.holdOrderCost
                        ?.total_order_amount ?? 0
                    }`
                  : `Billing amount - ${
                      tabData?.totalHoldBillingValue?.holdOrderCost
                        ?.total_order_amount ?? 0
                    }`
              }
              subValue={
                (USER_ROLE === 4 || USER_ROLE === 5)
                  ? [
                      `HCV - ${
                        tabData?.overAllTotalHoldBillingValue?.holdQuantity?.HCV
                          ?.ordered_quantity ?? 0
                      }`,
                      `LCV - ${
                        tabData?.overAllTotalHoldBillingValue?.holdQuantity?.LCV
                          ?.ordered_quantity ?? 0
                      }`,
                      `TRL - ${
                        tabData?.overAllTotalHoldBillingValue?.holdQuantity?.TRL
                          ?.ordered_quantity ?? 0
                      }`,
                      `OHW - ${
                        tabData?.overAllTotalHoldBillingValue?.holdQuantity?.OHW
                          ?.ordered_quantity ?? 0
                      }`,
                    ]
                  : [
                      `HCV - ${
                        tabData?.totalHoldBillingValue?.holdQuantity?.HCV
                          ?.ordered_quantity ?? 0
                      }`,
                      `LCV - ${
                        tabData?.totalHoldBillingValue?.holdQuantity?.LCV
                          ?.ordered_quantity ?? 0
                      }`,
                      `TRL - ${
                        tabData?.totalHoldBillingValue?.holdQuantity?.TRL
                          ?.ordered_quantity ?? 0
                      }`,
                      `OHW - ${
                        tabData?.totalHoldBillingValue?.holdQuantity?.OHW
                          ?.ordered_quantity ?? 0
                      }`,
                    ]
              }
              flexBasis="20%"
            />
            <Card
              title="Total Rejected Orders"
              value={
                (USER_ROLE === 4 || USER_ROLE === 5)
                  ? `Billing amount - ${
                      tabData?.overAllTotalRejectBillingValue?.rejectOrderCost
                        ?.total_order_amount ?? 0
                    }`
                  : `Billing amount - ${
                      tabData?.totalRejectBillingValue?.rejectOrderCost
                        ?.total_order_amount ?? 0
                    }`
              }
              subValue={
                (USER_ROLE === 4 || USER_ROLE === 5)
                  ? [
                      `HCV - ${
                        tabData?.overAllTotalRejectBillingValue?.holdQuantity
                          ?.HCV?.ordered_quantity ?? 0
                      }`,
                      `LCV - ${
                        tabData?.overAllTotalRejectBillingValue?.holdQuantity
                          ?.LCV?.ordered_quantity ?? 0
                      }`,
                      `TRL - ${
                        tabData?.overAllTotalRejectBillingValue?.holdQuantity
                          ?.TRL?.ordered_quantity ?? 0
                      }`,
                      `OHW - ${
                        tabData?.overAllTotalRejectBillingValue?.holdQuantity
                          ?.OHW?.ordered_quantity ?? 0
                      }`,
                    ]
                  : [
                      `HCV - ${
                        tabData?.totalRejectBillingValue?.holdQuantity?.HCV
                          ?.ordered_quantity ?? 0
                      }`,
                      `LCV - ${
                        tabData?.totalRejectBillingValue?.holdQuantity?.LCV
                          ?.ordered_quantity ?? 0
                      }`,
                      `TRL - ${
                        tabData?.totalRejectBillingValue?.holdQuantity?.TRL
                          ?.ordered_quantity ?? 0
                      }`,
                      `OHW - ${
                        tabData?.totalRejectBillingValue?.holdQuantity
                          ?.OHW?.ordered_quantity ?? 0
                      }`,
                    ]
              }
              flexBasis="20%"
            />
          </div> */}
          <div className="p-4">
            <div className="flex flex-col md:flex-row gap-4 overflow-scroll" style={{ scrollbarWidth: 'none' }}>
              <LeftTable tabData={tabData} />
              <RightTable
                title="Total Sets (Dispatched)"
                icon={<svg width="49" height="49" viewBox="0 0 49 49" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g filter="url(#filter0_d_1135_1365)">
                <path d="M8 10.8C8 8.14903 10.149 6 12.8 6H32C34.651 6 36.8 8.14903 36.8 10.8V30C36.8 32.651 34.651 34.8 32 34.8H12.8C10.149 34.8 8 32.651 8 30V10.8Z" fill="#00A584"/>
                <path d="M12.7998 6.5H32C34.3748 6.5 36.2997 8.42507 36.2998 10.7998V30C36.2998 32.3748 34.3748 34.2998 32 34.2998H12.7998C10.4251 34.2997 8.5 32.3748 8.5 30V10.7998C8.50011 8.42514 10.4251 6.50011 12.7998 6.5Z" stroke="#00765E"/>
                <g clip-path="url(#clip0_1135_1365)">
                <path d="M26 20.5L21 17.5L26 14.5L31 17.5V23L26 26V20.5Z" stroke="white" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M21 17.5V23L26 26" stroke="white" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M26 20.5451L31 17.5151" stroke="white" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M17 17H12" stroke="white" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M17 20H14" stroke="white" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M17 23H16" stroke="white" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
                </g>
                </g>
                <defs>
                <filter id="filter0_d_1135_1365" x="0" y="0" width="48.8" height="48.7998" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                <feFlood flood-opacity="0" result="BackgroundImageFix"/>
                <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
                <feOffset dx="2" dy="4"/>
                <feGaussianBlur stdDeviation="5"/>
                <feComposite in2="hardAlpha" operator="out"/>
                <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"/>
                <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1135_1365"/>
                <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1135_1365" result="shape"/>
                </filter>
                <clipPath id="clip0_1135_1365">
                <rect width="24" height="24" fill="white" transform="translate(10 8)"/>
                </clipPath>
                </defs>
                </svg>
                }
                headers={['HCV', 'LCV', 'TRL', 'OHW']}
                data={tabData?.map(item => [
                  item?.overAllTotalBilledQuantity?.HCV?.approved_quantity,
                  item?.overAllTotalBilledQuantity?.LCV?.approved_quantity,
                  item?.overAllTotalBilledQuantity?.TRL?.approved_quantity,
                  item?.overAllTotalBilledQuantity?.OHW?.approved_quantity,
                ])}
              />
              <RightTable
                title="Total Hold Orders"
                icon={<svg width="49" height="49" viewBox="0 0 49 49" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <g filter="url(#filter0_d_1135_1407)">
                  <path d="M8 10.9001C8 8.24913 10.149 6.1001 12.8 6.1001H32C34.651 6.1001 36.8 8.24913 36.8 10.9001V30.1001C36.8 32.7511 34.651 34.9001 32 34.9001H12.8C10.149 34.9001 8 32.7511 8 30.1001V10.9001Z" fill="#00A584"/>
                  <path d="M12.7998 6.6001H32C34.3748 6.6001 36.2997 8.52517 36.2998 10.8999V30.1001C36.2998 32.4749 34.3748 34.3999 32 34.3999H12.7998C10.4251 34.3998 8.5 32.4749 8.5 30.1001V10.8999C8.50011 8.52523 10.4251 6.6002 12.7998 6.6001Z" stroke="#00765E"/>
                  <g clip-path="url(#clip0_1135_1407)">
                  <path d="M22.9403 28.5803H16.7803C16.3139 28.5803 15.8659 28.3946 15.5359 28.0646C15.2059 27.7346 15.0203 27.2867 15.0203 26.8203V18.0203C15.0203 17.5539 15.2059 17.1059 15.5359 16.7759C15.8659 16.4459 16.3139 16.2603 16.7803 16.2603H18.5403M29.1003 19.0059V18.0203C29.1003 17.5539 28.9146 17.1059 28.5846 16.7759C28.2546 16.4459 27.8067 16.2603 27.3403 16.2603H25.5803" stroke="white" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M25.5802 18.9004V13.6204C25.5802 13.154 25.3945 12.706 25.0645 12.376C24.7345 12.046 24.2866 11.8604 23.8202 11.8604H20.3002C19.8338 11.8604 19.3858 12.046 19.0558 12.376C18.7258 12.706 18.5402 13.154 18.5402 13.6204V18.9004M25.5802 18.9004H18.5402M25.5802 18.9004H26.4602M18.5402 18.9004H17.6602" stroke="white" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M18.54 22.4204V22.4284" stroke="white" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M18.54 25.0601V25.0681" stroke="white" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M22.0601 22.4116V22.4196" stroke="white" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M22.0601 25.0601V25.0681" stroke="white" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M30.7497 22.292H25.708H27.083C27.5692 22.292 28.0356 22.4851 28.3794 22.829C28.7232 23.1728 28.9163 23.6391 28.9163 24.1253C28.9163 24.6116 28.7232 25.0779 28.3794 25.4217C28.0356 25.7655 27.5692 25.9587 27.083 25.9587H25.708L28.458 28.7087" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M25.708 24.125H30.7497" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
                  </g>
                  </g>
                  <defs>
                  <filter id="filter0_d_1135_1407" x="0" y="0.100098" width="48.8" height="48.7998" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                  <feFlood flood-opacity="0" result="BackgroundImageFix"/>
                  <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
                  <feOffset dx="2" dy="4"/>
                  <feGaussianBlur stdDeviation="5"/>
                  <feComposite in2="hardAlpha" operator="out"/>
                  <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"/>
                  <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1135_1407"/>
                  <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1135_1407" result="shape"/>
                  </filter>
                  <clipPath id="clip0_1135_1407">
                  <rect width="21.12" height="21.12" fill="white" transform="translate(11.5 10.1001)"/>
                  </clipPath>
                  </defs>
                  </svg>
                  }
                billingAmount={tabData[0]?.overAllTotalHoldBillingValue?.holdOrderCost?.total_order_amount}
                headers={['HCV', 'LCV', 'TRL', 'OHW']}
                data={tabData?.map(item => [
                  item?.overAllTotalHoldBillingValue?.holdQuantity?.HCV?.ordered_quantity,
                  item?.overAllTotalHoldBillingValue?.holdQuantity?.LCV?.ordered_quantity,
                  item?.overAllTotalHoldBillingValue?.holdQuantity?.TRL?.ordered_quantity,
                  item?.overAllTotalHoldBillingValue?.holdQuantity?.OHW?.ordered_quantity,
                ])}
              />
              <RightTable
                title="Total Rejected Orders"
                icon={<svg width="49" height="49" viewBox="0 0 49 49" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g filter="url(#filter0_d_1135_1451)">
                    <path d="M8 10.9001C8 8.24913 10.149 6.1001 12.8 6.1001H32C34.651 6.1001 36.8 8.24913 36.8 10.9001V30.1001C36.8 32.7511 34.651 34.9001 32 34.9001H12.8C10.149 34.9001 8 32.7511 8 30.1001V10.9001Z" fill="#00A584"/>
                    <path d="M12.7998 6.6001H32C34.3748 6.6001 36.2997 8.52517 36.2998 10.8999V30.1001C36.2998 32.4749 34.3748 34.3999 32 34.3999H12.7998C10.4251 34.3998 8.5 32.4749 8.5 30.1001V10.8999C8.50011 8.52523 10.4251 6.6002 12.7998 6.6001Z" stroke="#00765E"/>
                    <path d="M19.5836 14.5H18.1142C17.6595 14.5 17.2235 14.6896 16.902 15.0272C16.5805 15.3648 16.3999 15.8226 16.3999 16.3V27.1C16.3999 27.5774 16.5805 28.0352 16.902 28.3728C17.2235 28.7104 17.6595 28.9 18.1142 28.9H26.6856C27.1403 28.9 27.5763 28.7104 27.8978 28.3728C28.2193 28.0352 28.3999 27.5774 28.3999 27.1V16.3C28.3999 15.8226 28.2193 15.3648 27.8978 15.0272C27.5763 14.6896 27.1403 14.5 26.6856 14.5H25.121" stroke="white" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M20.1 15.1499H24.7C24.8657 15.1499 25 15.0156 25 14.8499V14.6499C25 13.5453 24.1046 12.6499 23 12.6499H21.8C20.6955 12.6499 19.8 13.5453 19.8 14.6499V14.8499C19.8 15.0156 19.9344 15.1499 20.1 15.1499Z" stroke="white"/>
                    <path d="M20.4797 24.7L24.6797 20.5M20.4797 20.5L24.6797 24.7" stroke="white" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
                    </g>
                    <defs>
                    <filter id="filter0_d_1135_1451" x="0" y="0.100098" width="48.8" height="48.7998" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                    <feFlood flood-opacity="0" result="BackgroundImageFix"/>
                    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
                    <feOffset dx="2" dy="4"/>
                    <feGaussianBlur stdDeviation="5"/>
                    <feComposite in2="hardAlpha" operator="out"/>
                    <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"/>
                    <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1135_1451"/>
                    <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1135_1451" result="shape"/>
                    </filter>
                    </defs>
                    </svg>
                    }
                billingAmount={tabData[0]?.overAllTotalRejectBillingValue?.rejectOrderCost?.total_order_amount}
                headers={['HCV', 'LCV', 'TRL', 'OHW']}
                data={tabData?.map(item => [
                  item?.overAllTotalRejectBillingValue?.holdQuantity?.HCV?.ordered_quantity,
                  item?.overAllTotalRejectBillingValue?.holdQuantity?.LCV?.ordered_quantity,
                  item?.overAllTotalRejectBillingValue?.holdQuantity?.TRL?.ordered_quantity,
                  item?.overAllTotalRejectBillingValue?.holdQuantity?.OHW?.ordered_quantity,
                ])}
              />
            </div>
          </div>
          <div className="p-2">
            <div className="mb-6">
            <div className="">
              <div className="grid grid-cols-1 md:flex md:space-x-2 w-full gap-1 custom-grid mb-2">
                {/* {USER_ROLE === 3 && (
                  <> */}
                  <div
                      className={`relative w-full ${
                        (USER_ROLE === 4 || USER_ROLE === 5) ? "md:w-[315px]" : "md:w-[250px]"
                      }`}
                    >
                      <Search className="absolute left-1 top-2 h-5 w-5 text-gray-400" />
                      {(USER_ROLE === 4 || USER_ROLE === 5) ? (
                        <input
                          type="text"
                          value={filter.distrNameOrNumber}
                          onKeyDown={handleKeyDown}
                          onChange={(e) =>
                            setFilter({ ...filter, distrNameOrNumber: e.target.value })
                          }
                          placeholder="Search by Dist name/Number"
                          className="w-full pl-8 pr-1 py-1 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary"
                        />
                      ) : (
                        <input
                          type="text"
                          value={filter.order_id}
                          onKeyDown={handleKeyDown}
                          onChange={(e) =>
                            setFilter({
                              ...filter,
                              order_id:
                                e.target.value === "" ? undefined : e.target.value,
                            })
                          }
                          placeholder="Search by Order ID"
                          className="w-full pl-8 pr-1 py-1 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary"
                        />
                      )}
                    </div>
                    <Datepicker
                      displayFormat="DD/MM/YYYY"
                      primaryColor={"emerald"}
                      value={value}
                      defaultValue={null}
                      clearable={true}
                      isOpen={isOpen}
                      toggleClassName="hidden"
                      inputClassName="border border-gray-300 rounded-lg px-2 py-1 w-full cursor-pointer"
                      containerClassName="relative z-50 min-w-[235px]"
                      popoverDirection="down"
                      onChange={(newValue) => setValue(newValue)}
                      showShortcuts={true}
                      inputProps={{ placeholder: "Select a date range" }}
                      popperOptions={{ placement: "bottom-start" }}
                      onBlur={() => setIsOpen(false)}
                    />
                  {/* </>
                )} */}

                <select
                  className="border border-gray-300 rounded-lg px-2 py-1 w-full md:w-auto"
                  value={
                    filter?.status_id?.length
                      ? filter.status_id[filter.status_id.length - 1]
                      : ""
                  }
                  onChange={(e) => {
                    const selectedValue = e.target.value;

                    setFilter((prevFilter) => {
                      const currentStatus = prevFilter.status_id || [];

                      const updatedStatusId = selectedValue
                        ? currentStatus.includes(selectedValue)
                          ? currentStatus
                          : [Number(selectedValue)]
                        : undefined;

                      return { ...prevFilter, status_id: updatedStatusId };
                    });
                  }}
                >
                  <option value="">All Order Status</option>
                  {statusOptions.map((val, i) => {
                    return (
                      <option key={val.value} value={val.value}>
                        {val.label}
                      </option>
                    );
                  })}
                </select>

                {(USER_ROLE === 4) && (
                  <select
                    className="border border-gray-300 rounded-lg px-2 py-1 w-full md:w-auto"
                    value={
                      filter?.region_id?.length
                        ? filter.region_id[filter.region_id.length - 1]
                        : ""
                    }
                    onChange={(e) => {
                      const selectedValue = e.target.value;

                      setFilter((prevFilter) => {
                        const currentStatus = prevFilter.region_id || [];

                        const updatedStatusId = selectedValue
                          ? currentStatus.includes(selectedValue)
                            ? currentStatus
                            : [Number(selectedValue)]
                          : undefined;

                        return { ...prevFilter, region_id: updatedStatusId };
                      });
                    }}
                    disabled={filter?.zonal_manager_id}
                  >
                    <option value="">All Zone</option>
                    {zoneOptions.map((val, i) => {
                      return (
                        <option key={val.value} value={val.value}>
                          {val.label}
                        </option>
                      );
                    })}
                  </select>
                )}

                {(USER_ROLE === 4) && (
                  <select
                    className="border border-gray-300 rounded-lg px-2 py-1 w-full md:w-auto"
                    value={
                      filter?.zonal_manager_id
                        ? filter.zonal_manager_id
                        : ""
                    }
                    onChange={(e) => {
                      const selectedValue = e.target.value;

                      setFilter((prevFilter) => {
                        const currentStatus = prevFilter.zonal_manager_id || [];

                        const updatedStatusId = selectedValue
                          ? currentStatus == selectedValue
                            ? currentStatus
                            : Number(selectedValue)
                          : undefined;

                        return { ...prevFilter, zonal_manager_id: updatedStatusId };
                      });
                    }}
                  >
                    <option value="">All Zonal Manager</option>
                    {zonalManagers.length > 0 ? zonalManagers.map((val, i) => {
                      return (
                        <option key={val.value} value={val.value}>
                          {val.label}
                        </option>
                      );
                    }): <p style={{marginLeft: '5px'}}>No data</p>}
                  </select>
                )}

                {(USER_ROLE === 4 || USER_ROLE === 5) && (
                  <select
                    className="border border-gray-300 rounded-lg px-2 py-1 w-full md:w-[230px]"
                    value={filter.state_id}
                    onChange={(e) =>
                      setFilter({
                        ...filter,
                        state_id: e.target.value
                          ? [Number(e.target.value)]
                          : undefined,
                      })
                    }
                  >
                    <option value="">All State</option>
                    {states.map((state) => {
                      return (
                        <option key={state.state_id} value={state.state_id}>
                          {state.state_name}
                        </option>
                      );
                    })}
                  </select>
                )}

                </div>
                {/* <div></div> */}
                <div className="grid grid-cols-1 md:flex md:space-x-2 w-full gap-1 custom-grid">
                {(USER_ROLE === 4 || USER_ROLE === 5) && (
                  <select
                    className="border border-gray-300 rounded-lg px-2 py-1 w-full md:w-[230px]"
                    value={filter.district_id}
                    disabled={!filter.state_id || filter.state_id.length === 0}
                    onChange={(e) =>
                      setFilter({
                        ...filter,
                        district_id: e.target.value
                          ? [Number(e.target.value)]
                          : undefined,
                      })
                    }
                  >
                    <option value="">All District</option>
                    {districts?.map((district) => {
                      return (
                        <option key={district?.id} value={district.id}>
                          {district?.name}
                        </option>
                      );
                    })}
                  </select>
                )}

                {/* <button
                  className="w-full md:w-auto px-2 py-1 bg-emerald-500 text-white text-sm rounded hover:bg-emerald-600 transition"
                  onClick={handleSearch}
                >
                  Apply
                </button> */}

                <button
                  className="w-full md:w-auto px-2 py-1 border-2 text-black rounded-lg transition summary-reset-button"
                  onClick={handleReset}
                >
                  Reset
                </button>
                </div>
              </div>
            </div>
          </div>

          <div className="overflow-auto h-[250px] sm:h-[400px] md:h-[450px] xl:h-[600px] rounded-lg">
            <table className="min-w-full overflow-auto divide-y divide-gray-200">
              <thead>
                <tr className="bg-emerald-200">
                  <th className="p-3 text-left text-sm font-bold text-gray-700 ">
                    Order ID
                  </th>
                  {(USER_ROLE === 4 || USER_ROLE === 5) && (
                    <th className="p-3 text-left text-sm font-bold text-gray-700 ">
                      Distributor Name
                    </th>
                  )}
                    <th className="p-3 text-left text-sm font-bold text-gray-700 ">
                      Added By
                    </th>
                  {(USER_ROLE === 4) && (
                    <th className="p-3 text-left text-sm font-bold text-gray-700 ">
                      Zonal Manager Name
                    </th>
                  )}
                  {(USER_ROLE === 4 || USER_ROLE === 5) && (
                    <th className="p-3 text-left text-sm font-bold text-gray-700 ">
                      Distributor Number
                    </th>
                  )}
                  {(USER_ROLE === 4) && (
                    <th className="p-3 text-left text-sm font-bold text-gray-700 ">
                      Zone
                    </th>
                  )}
                  {(USER_ROLE === 4 || USER_ROLE === 5) && (
                    <th className="p-3 text-left text-sm font-bold text-gray-700 ">
                      State
                    </th>
                  )}
                  <th className="p-3 text-left text-sm font-bold text-gray-700 ">
                    Order Date
                  </th>
                  <th className="p-3 text-left text-sm font-bold text-gray-700 ">
                    Order Status
                  </th>
                  <th className="p-3 text-center text-sm font-bold text-gray-700 ">
                    Total Sets Ordered
                  </th>
                  {
                    <th className="p-3 text-center text-sm font-bold text-gray-700 ">
                      Total Sets Billed
                    </th>
                  }
                  {
                    <th className="p-3 text-center text-sm font-bold text-gray-700 ">
                      HCV Sets 
                    </th>
                  }
                  {
                    <th className="p-3 text-center text-sm font-bold text-gray-700 ">
                      LCV Sets
                    </th>
                  }
                  {
                    <th className="p-3 text-center text-sm font-bold text-gray-700 ">
                      TRL Sets
                    </th>
                  }
                  {
                    <th className="p-3 text-center text-sm font-bold text-gray-700 ">
                      OHW Sets
                    </th>
                  }
                  {
                    <th className="p-3 text-center text-sm font-bold text-gray-700 ">
                      Billing Value
                    </th>
                  }
                  {
                    <th className="p-3 text-center text-sm font-bold text-gray-700 ">
                      Invoice Value
                    </th>
                  }
                  {
                    <th className="p-3 text-center text-sm font-bold text-gray-700 ">
                      Invoice No
                    </th>
                  }
                  {
                    <th className="p-3 text-center text-sm font-bold text-gray-700 ">
                      Dispatch Status
                    </th>
                  }
                  {
                    <th className="p-3 text-center text-sm font-bold text-gray-700 ">
                      Delivery Date
                    </th>
                  }
                </tr>
              </thead>
              {summary.length != 0 ? (
                <tbody className="bg-white divide-y divide-gray-200">
                  {summary.map((data, index) => {
                    return (
                      <tr key={data?.order_id} className="bg-white">
                        <td className="p-3 whitespace-nowrap text-sm text-gray-800 text-left">
                          {data?.master_parent_order_id &&
                          data?.order_sequence_alphabet
                            ? `${data?.master_parent_order_id}-${data?.order_sequence_alphabet}`
                            : data?.order_id}
                        </td>
                        {(USER_ROLE === 4 || USER_ROLE === 5) && (
                          <td className="p-3 whitespace-nowrap text-sm text-gray-800 text-center">
                            {data?.distributor_name ?? "NA"}
                          </td>
                        )}
                        {/* {(USER_ROLE === 4) && ( */}
                          <td className="p-3 whitespace-nowrap text-sm text-gray-800 text-center">
                            {data?.added_by_type
                        ? data.added_by_type.toLowerCase().replace(/(^\w|_\w)/g, m => m.replace("_", " ").toUpperCase())
                        : "N/A"}
                          </td>
                        {/* )} */}
                        {(USER_ROLE === 4) && (
                          <td className="p-3 whitespace-nowrap text-sm text-gray-800 text-center">
                            {data?.manager_name || "N/A"}
                          </td>
                        )}
                        {(USER_ROLE === 4 || USER_ROLE === 5) && (
                          <td className="p-3 whitespace-nowrap text-sm text-gray-800 text-center">
                            {data?.mobile ?? "NA"}
                          </td>
                        )}
                        {USER_ROLE === 4 && (
                          <td className="p-3 whitespace-nowrap text-sm text-gray-800 text-center">
                            {data?.region_id
                              ? zoneOptions.find(
                                  (zone) => zone.value === data?.region_id
                                ).label
                              : "NA"}
                          </td>
                        )}
                        {(USER_ROLE === 4 || USER_ROLE === 5) && (
                          <td className="p-3 whitespace-nowrap text-sm text-gray-800 text-center">
                            {data?.state_id
                              ? states?.find(
                                  (state) => state?.state_id === data?.state_id
                                )?.state_name
                              : "NA"}
                          </td>
                        )}
                        <td className="p-3 whitespace-nowrap text-sm text-gray-800 text-center">
                          {data?.order_date ?? "NA"}
                        </td>
                        <td className="p-3 whitespace-nowrap text-sm text-gray-800 text-center">
                          {data?.display_status ?? "NA"}
                        </td>
                        <td className="p-3 whitespace-nowrap text-sm text-gray-800 text-right">
                          {data?.total_ordered_quantity ?? "NA"}
                        </td>
                        <td className="p-3 whitespace-nowrap text-sm text-gray-800 text-right">
                          {data?.total_approved_quantity ?? "NA"}
                        </td>
                        <td className="p-3 whitespace-nowrap text-sm text-gray-800 text-right">
                          {data?.hcv_quantity ?? "NA"}
                        </td>
                        <td className="p-3 whitespace-nowrap text-sm text-gray-800 text-right">
                          {data?.lcv_quantity ?? "NA"}
                        </td>
                        <td className="p-3 whitespace-nowrap text-sm text-gray-800 text-right">
                          {data?.trl_quantity ?? "NA"}
                        </td>
                        <td className="p-3 whitespace-nowrap text-sm text-gray-800 text-right">
                          {data?.ohw_quantity ?? "NA"}
                        </td>
                        <td className="p-3 whitespace-nowrap text-sm text-gray-800 text-right">
                          {data?.approved_amount ?? data?.order_amount ?? "NA"}
                        </td>
                        <td className="p-3 whitespace-nowrap text-sm text-gray-800 text-right">
                          {data?.invoice_amount ?? "NA"}
                        </td>
                        <td className="p-3 whitespace-nowrap text-sm text-gray-800 text-center">
                          {data?.invoice_number ?? "NA"}
                        </td>
                        <td className="p-3 whitespace-nowrap text-sm text-gray-800 text-center">
                          {data?.dispatch_status ?? "NA"}
                        </td>
                        <td className="p-3 whitespace-nowrap text-sm text-gray-800 text-center">
                          {data?.delivered_confirm_date ?? "NA"}
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              ) : (
                <tbody>
                  <tr>
                    <td
                      className="p-3 whitespace-nowrap text-sm text-center text-gray-900"
                      colSpan={8}
                    >
                      No Summary Available
                    </td>
                  </tr>
                </tbody>
              )}
            </table>

            {totalCount !== null && (
              <div className="flex justify-center mt-2">
                <Stack spacing={2}>
                  <Pagination
                    count={totalPages}
                    page={currentPage}
                    onChange={(event, value) => handlePageChange(value)}
                    variant="outlined"
                    shape="rounded"
                    color="primary"
                    size="10"
                  />
                </Stack>
              </div>
            )}
          </div>
        </div>

        {isModalOpen && (
          <ProductModal
            closeModal={() => setIsModalOpen(false)}
            Close
            modal
            function
          />
        )}
      </>
    );
};

export default SummaryTable;